<template>
  <div class="container-fluid">
    <div class="row mb-3 align-items-center">
      <div class="col">
        <h4 class="mb-1">Cupones</h4>
        <p class="text-muted mb-0">
          Alta y gestión de códigos de descuento para clientes (vigencia, límites y canjes).
        </p>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" @click="goAlta">Nuevo cupón</button>
      </div>
    </div>

    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
    <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5 text-muted">Cargando cupones…</div>
        <div v-else class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Código</th>
                <th>Inicio</th>
                <th>Expiración</th>
                <th>Descuento</th>
                <th>Compra mín.</th>
                <th>Por usuario</th>
                <th>Máx. total</th>
                <th>Canjeados</th>
                <th>Estado</th>
                <th class="text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in rows" :key="row.id">
                <td><strong>{{ row.code }}</strong></td>
                <td>{{ formatDate(row.dateStart) }}</td>
                <td>{{ formatDate(row.dateExpiration) }}</td>
                <td>
                  <span v-if="row.discountType === 'porcentaje'">{{ row.amount }}%</span>
                  <span v-else>${{ formatMoney(row.amount) }}</span>
                </td>
                <td>${{ formatMoney(row.minimumPurchase) }}</td>
                <td>{{ row.timePerUser }}</td>
                <td>{{ row.maximumCoupons || '∞' }}</td>
                <td>{{ row.redemptionCount }}</td>
                <td>
                  <span :class="row.isActive ? 'badge badge-success' : 'badge badge-secondary'">
                    {{ row.isActive ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
                <td class="text-right text-nowrap">
                  <button class="btn btn-sm btn-outline-primary mr-1" @click="goEdit(row)">
                    Editar
                  </button>
                  <button
                    v-if="row.isActive"
                    class="btn btn-sm btn-outline-warning mr-1"
                    @click="deactivate(row)"
                  >
                    Desactivar
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="confirmDelete(row)">
                    Eliminar
                  </button>
                </td>
              </tr>
              <tr v-if="!rows.length">
                <td colspan="10" class="text-center text-muted py-4">No hay cupones.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { deleteCupon, fetchCupones, updateCupon } from '@/services/cuponesApi';

export default {
  name: 'CuponesPage',
  data() {
    return {
      loading: true,
      rows: [],
      errorMessage: '',
      successMessage: '',
    };
  },
  created() {
    if (this.$route.query.saved) {
      this.successMessage = 'Cupón guardado correctamente';
    }
    this.load();
  },
  methods: {
    formatDate(iso) {
      if (!iso) return '—';
      const d = new Date(iso);
      if (Number.isNaN(d.getTime())) return '—';
      return d.toLocaleDateString('es-CL');
    },
    formatMoney(n) {
      return Number(n || 0).toLocaleString('es-CL');
    },
    async load() {
      this.loading = true;
      this.errorMessage = '';
      try {
        this.rows = await fetchCupones();
      } catch (e) {
        this.rows = [];
        this.errorMessage = e.message || 'No se pudieron cargar los cupones';
      } finally {
        this.loading = false;
      }
    },
    goAlta() {
      this.$router.push({ name: 'cupones-alta' });
    },
    goEdit(row) {
      this.$router.push({ name: 'cupones-editar', params: { id: row.id } });
    },
    async deactivate(row) {
      try {
        await updateCupon(row.id, { status: 'disabled' });
        this.successMessage = `Cupón ${row.code} desactivado`;
        await this.load();
      } catch (e) {
        this.errorMessage = e.message || 'No se pudo desactivar';
      }
    },
    async confirmDelete(row) {
      const result = await Swal.fire({
        title: '¿Eliminar cupón?',
        text: row.code,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });
      if (!result.isConfirmed) return;
      try {
        await deleteCupon(row.id);
        this.successMessage = 'Cupón eliminado';
        await this.load();
      } catch (e) {
        this.errorMessage = e.message || 'No se pudo eliminar';
      }
    },
  },
};
</script>
